<div class="formgrid grid">
  <ng-container *ngIf="locationRequired">
    <div *ngIf="this.changeType" class="field col-12">
      <label *ngIf="this.showLabels">Location Type:</label>
      <span class="w-100">
        <p-dropdown
          [(ngModel)]="locationTypeOption"
          [options]="locationTypeOptions"
        ></p-dropdown>
      </span>
    </div>
    <div class="field col-12 mb-2">
      <label *ngIf="this.showLabels" class="mb-0">
        {{ locationTypeOption === 'All' ? 'Locations' : locationTypeOption }}
      </label>

      <ng-template #multiLocations>
        <span class="w-100">
          <p-multiSelect
            #multiSelect
            (onChange)="handleLocationSelection($event)"
            [(ngModel)]="selectedLocations"
            [emptyFilterMessage]="
              'No results matched your filter, clear your filter and try again.'
            "
            [options]="locationFilteredResults"
            [placeholder]="placeHolderText"
            filter="name"
            filterMatchMode="contains"
            optionLabel="name"
            [filter]="true"
            display="chip"
            [showHeader]="!loadingLocations"
            (onFilter)="updateFilters($event)"
            [selectedItemsLabel]="'{0} items selected'"
          >
            <!-- <ng-template let-value pTemplate="selectedItems">
            <div *ngFor="let location of selectedLocations">
              <i
                [class]="
                  location.type == 'location'
                    ? 'material-icons-round mi-place'
                    : 'material-icons-round mi-commute'
                "
                style="vertical-align: middle; font-size: 1rem;"
              ></i>
              {{ location.name }}
            </div>
            <ng-container *ngIf="!selectedLocations?.length">
              {{ placeHolderText }}
            </ng-container>
          </ng-template> -->
            <ng-template pTemplate="empty">
              <ng-container *ngIf="loadingLocations">
                Loading Locations....
              </ng-container>
              <ng-container
                *ngIf="!loadingLocations && !locationSearchResults?.length"
              >
                We seem to have had some trouble finding the locations, please
                check that there are locations loaded for this entity.
              </ng-container>
            </ng-template>
            <ng-template pTemplate="emptyfilter">
              <div class="text-center">
                <p>
                  There are no locations matching your required filter, try
                  searching globally.
                </p>

                <p-button
                  (click)="searchAllLocations()"
                  icon="pi pi-search"
                  label="Search All Locations and Vehicles"
                  styleClass="p-button-lg p-button-success"
                ></p-button>
              </div>
            </ng-template>
            <!-- <ng-template pTemplate="footer">
          Filter between vehicles and locations?
        </ng-template> -->

            <ng-template let-location pTemplate="item">
              <div style="font-size: 18px">
                <i
                  [class]="
                    location.type == 'location' || location.type == 'Physical'
                      ? 'material-icons-round mi-place'
                      : 'material-icons-round mi-commute'
                  "
                  style="vertical-align: middle"
                ></i>
                {{ location.name }}
              </div>
            </ng-template>
            <ng-template pTemplate="footer">
              <div
                class="flex p-flex-column p-justify-between p-2 align-items-center p-flex-md-row"
              >
                <div class="mb-2 mr-2">
                  <p>{{ selectedLocations?.length || 0 }} selected</p>
                </div>

                <div class="mb-2 mr-2">
                  <button
                    class="p-button-text p-button-primary"
                    label="Clear"
                    pButton
                    pRipple
                    (click)="clearLocationSelection()"
                    [disabled]="!selectedLocations?.length"
                  ></button>
                </div>
              </div>
            </ng-template>
          </p-multiSelect>
        </span>
      </ng-template>

      <ng-container *ngIf="singleLocation; else multiLocations">
        <span class="p-fluid">
          <p-dropdown
            (onChange)="handleLocationSelection($event)"
            [options]="locationFilteredResults"
            [(ngModel)]="selectedLocations && selectedLocations[0]"
            optionLabel="name"
            [placeholder]="placeHolderText"
            [filter]="true"
            filterPlaceholder="Filter Locations"
            (onFilter)="handleFilter($event)"
          >
            <ng-template pTemplate="selectedItem">
              <div *ngIf="selectedLocations">
                <i
                  [class]="
                    selectedLocations[0].type == 'location'
                      ? 'material-icons-round mi-place'
                      : 'material-icons-round mi-commute'
                  "
                  style="vertical-align: middle; font-size: 1rem"
                ></i>
                {{ selectedLocations[0].name }}
              </div>
            </ng-template>
            <ng-template pTemplate="empty">
              <ng-container *ngIf="loadingLocations">
                Loading Locations....
              </ng-container>
              <ng-container
                *ngIf="!loadingLocations && !locationSearchResults?.length"
              >
                We seem to have had some trouble finding the locations, please
                check that there are locations loaded for this entity.
              </ng-container>
            </ng-template>
            <ng-template pTemplate="footer">
              <div
                class="flex p-flex-column p-justify-between p-2 align-items-center p-flex-md-row"
              >
                <div class="mb-2 mr-2"></div>

                <div class="mb-2 mr-2">
                  <button
                    class="p-button-text p-button-primary"
                    label="Clear"
                    pButton
                    pRipple
                    (click)="clearLocationSelection()"
                    [disabled]="!selectedLocations?.length"
                  ></button>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="emptyfilter">
              <div class="text-center">
                <p>
                  There are no locations matching your required filter, try
                  searching globally.
                </p>

                <p-button
                  (click)="searchAllLocations()"
                  icon="pi pi-search"
                  label="Search All Locations and Vehicles"
                  styleClass="p-button-lg p-button-success"
                ></p-button>
              </div>
            </ng-template>
            <!-- <ng-template pTemplate="footer">
        Filter between vehicles and locations?
      </ng-template> -->

            <ng-template let-location pTemplate="item">
              <div style="font-size: 18px">
                <i
                  [class]="
                    location.type == 'location' || location.type == 'Physical'
                      ? 'material-icons-round mi-place'
                      : 'material-icons-round mi-commute'
                  "
                  style="vertical-align: middle"
                ></i>
                {{ location.name }}
              </div>
            </ng-template>
          </p-dropdown>
        </span>
      </ng-container>
    </div>
    <!-- TODO load these when the widget loads (prefetch locations) wrap it and limit it too. -->
    <!-- TODO Add Icon to indicate the Type of location vehicle fixed etc -->
    <ng-container *ngIf="this.showCards">
      <div class="field col-12">
        <div id="supplying-location">
          <div class="flex justify-content-center">
            <div
              *ngFor="let location of locationSearchResults"
              class="widget-pricing-card mr-2"
            >
              <h2>{{ location.name }}</h2>
              <span>{{ location.usageType }}</span>
              <h3 *ngIf="location.isHeadOffice">Head Office</h3>
              <!-- <ul>
              <li>{{location.usageType}}</li>
              <li>{{location.usageType}}</li>
            </ul> -->

              <a href="#">SELECT</a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="this.dateRequired">
    <ng-container *ngIf="!simpleDropDown">
      <div class="field col pr-0 mb-0">
        <label *ngIf="this.showLabels" for="startdate" class="mb-0">{{
          placeHolderDateText.from
        }}</label>
        <span class="p-fluid">
          <p-calendar
            #calendarStart
            [monthNavigator]="true"
            [yearNavigator]="true"
            yearRange="2022:2024"
            (onClearClick)="clearDateEvent()"
            (onSelect)="calendarDateSelection()"
            [(ngModel)]="startDate"
            (onInput)="inputDate($event)"
            [maxDate]="today"
            dateFormat="dd/mm/yy"
            inputId="startdate"
            [placeholder]="this.showLabels ? 'All' : placeHolderDateText.from"
            showButtonBar="true"
            [showOtherMonths]="false"
            [pTooltip]="placeHolderDateText.from"
            tooltipPosition="top"
            [showTime]="showTime"
            [showSeconds]="showTime"
            [touchUI]="isMobile"
          >
            <ng-template pTemplate="footer">
              <div class="col-12 py-0">
                <div class="flex flex-wrap justify-content-center">
                  <ng-container *ngFor="let chip of chips">
                    <p-chip
                      (click)="dateShortcut(chip.value)"
                      *ngIf="chip.visible"
                      [class.custom-chip]="chip.value === selectedChip"
                      [label]="chip.label"
                      styleClass="mr-2"
                    ></p-chip>
                  </ng-container>
                </div>
                <div class="col-12 py-0">
                  <div class="flex flex-wrap justify-content-center">
                    <ng-container *ngFor="let chip of chipsMonth">
                      <p-chip
                        (click)="dateShortcut(chip.value)"
                        *ngIf="chip.visible"
                        [class.custom-chip]="chip.value === selectedChip"
                        [label]="chip.label"
                        styleClass="mr-2"
                      ></p-chip>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-calendar>
        </span>
      </div>
      <!-- If not singleday show end date -->
      <div *ngIf="!this.singleDay" class="field col mb-0">
        <label *ngIf="this.showLabels" for="enddate" class="mb-0"
          >{{ placeHolderDateText.to }}
        </label>
        <span class="p-fluid">
          <p-calendar
            #calendarEnd
            [monthNavigator]="true"
            [yearNavigator]="true"
            yearRange="2022:2024"
            (onClearClick)="clearDateEvent()"
            (onSelect)="calendarDateSelection()"
            [(ngModel)]="endDate"
            [maxDate]="today"
            [minDate]="startDate"
            dateFormat="dd/mm/yy"
            inputId="enddate"
            [placeholder]="this.showLabels ? 'All' : placeHolderDateText.to"
            showButtonBar="true"
            [pTooltip]="placeHolderDateText.to"
            tooltipPosition="top"
            [showTime]="showTime"
            [showSeconds]="showTime"
            [touchUI]="isMobile"
          >
            <!-- <ng-template pTemplate="header">Header</ng-template> -->
            <ng-template pTemplate="footer">
              <div class="col-12 py-0">
                <div class="flex flex-wrap justify-content-center">
                  <ng-container *ngFor="let chip of chips">
                    <p-chip
                      (click)="dateShortcut(chip.value)"
                      *ngIf="chip.visible"
                      [class.custom-chip]="chip.value === selectedChip"
                      [label]="chip.label"
                      styleClass="mr-2"
                    ></p-chip>
                  </ng-container>
                </div>
                <div class="col-12 py-0">
                  <div class="flex flex-wrap justify-content-center">
                    <ng-container *ngFor="let chip of chipsMonth">
                      <p-chip
                        (click)="dateShortcut(chip.value)"
                        *ngIf="chip.visible"
                        [class.custom-chip]="chip.value === selectedChip"
                        [label]="chip.label"
                        styleClass="mr-2"
                      ></p-chip>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-calendar>
        </span>
      </div>
    </ng-container>
    <ng-container *ngIf="simpleDropDown">
      <div class="col-12">
        <span class="p-fluid">
          <p-dropdown
            (onChange)="dropDownChange($event)"
            [(ngModel)]="selectedDate"
            [options]="chips"
            [showClear]="true"
            optionLabel="label"
            placeholder="Select a Date"
          ></p-dropdown>
        </span>
      </div>
    </ng-container>
  </ng-container>
</div>
